// Lib
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// Styles
import './StyledFieldInfoText.scss';

const StyledFieldInfoText = (props) => {
    const { children, className } = props;

    return <div className={classNames('StyledFieldInfoText', className)}>{children}</div>;
};

StyledFieldInfoText.propTypes = {
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node, PropTypes.string]),
    className: PropTypes.string,
};

export default StyledFieldInfoText;
